<div class="w-full flex flex-col gap-3 items-start "> 

    @if (this.comentarios$ | async ; as comentarios) {
        <!--comments-->
        @for (comentario of comentarios; track $index) {
            <div class="flex flex-row gap-2 w-full">

                <user-avatar-name [name]="comentario.usuarioId.nombreCompleto"></user-avatar-name>

                <div class="commnet-details flex flex-col w-full">
                    <span class="font-bold text-sm">{{comentario.usuarioId.nombreCompleto}}</span>
                    <span class="text-xs"> comentó el : {{comentario.fechaCreacion | date : 'medium'}}</span>
                    <div class="comentario border rounded-sm p-4 w-full mt-3" >
                        <p class="text-xs font-light">{{comentario.descripcion}}</p>
                    </div>
                    @if(comentario.notificadoVa){
                        <p class="text-xs mt-1">Este comentario fue enviado al solicitante.</p>
                    }
                </div>
            </div>

        }

        @empty {
            <div class="w-full h-13"> 
                <h2>No hay Comentarios </h2>
            </div>
        }

    }

    <!-- Post Comment-->
    <div class="w-full border-t ">
        <div class="w-fullpt-3 p-3 mt-2 fuse-mat-dense border rounded-md">
            <textarea class="w-full"
             matInput [formControl]="comentarioForm.controls['comentario']" rows="3" placeholder="Ingrese su comentario de seguimiento"></textarea>
        </div>
        <section>
            <mat-checkbox [formControl]="comentarioForm.controls['notificar']"><p class="text-sm">Enviar notificación al solicitante</p></mat-checkbox>
        </section>
    </div>
    <div class="flex flex-row items-end justify-items-end w-full text-right -mt-2">
        <button color="primary" [disabled]="comentarioForm.invalid" (click)="agregarComentario()" mat-raised-button>Enviar</button>    
    </div>
    
    
</div>